module.exports = __webpack_public_path__ + "img/m-banner-tcawxgez-fr-FR.f3a32f49.jpg";